import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _templateObject;
const SvgComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 127 96",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M19.458 39.177l25.456 25.456 62.225-62.225c5.418-5.418 11.314 0 11.314 0l5.657 5.657s5.471 5.843 0 11.314L50.574 92.917c-3.825 3.825-8.315 2.871-11.314 0-2.999-2.871-31.172-31.172-36.77-36.77-5.598-5.598 0-11.314 0-11.314l5.657-5.657s5.755-5.556 11.311.001z",
      stroke: "none"
    })]
  });
};
const IconCheck = /*#__PURE__*/styled(SvgComponent).withConfig({
  displayName: "Check__IconCheck",
  componentId: "sc-pnlrh1-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  vertical-align: middle;\n"])));

export { IconCheck };
